import { Component, Input } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: 'app-poshvine-copy-code',
  templateUrl: './copy-code.component.html',
  styleUrls: ['./copy-code.component.scss']
})
export class CopyCodeComponent {

  @Input() public title: string = 'Code';
  @Input() public value: string = '';
  @Input() public isNoVoucherCode: boolean = false;
  public assetsPath = './../../../assets'

  constructor(
    private commonService: CommonService,
    private toastr: ToastrService

  ) {

  }

  public copyContent() {
    this.toastr.success('Copied!');
    this.commonService.copyContent(this.value);
  }
}
